; (function (jQuery) {

	"use strict";

	function GravityForms()
	{
		var global = {};

		var pub = {}

		var fn = {
			init: function ()
			{
				jQuery(document).ready(function ()
				{
                    // Reposition the spinner to the bottom of the page
					gform.addFilter('gform_spinner_target_elem', function(spinnerTargetElem, formId) {
						var customSpinnerTarget = jQuery('.gform_page_footer');
						if (customSpinnerTarget.length) {
							return customSpinnerTarget;
						}

						return spinnerTargetElem;
					});
				});
			},
        };

		jQuery(fn.init);
	}

	new GravityForms();
})(jQuery);